import { DataKeyDefine } from '@/defines/DataKeyDefine'

export class Utils {
  /**
   * 生成基于设备类型和时间戳的UUID
   * @returns 格式为：设备类型前缀-时间戳-随机数的UUID
   */
  public static getUUID(): string {
    let uuid = localStorage.getItem(DataKeyDefine.UUID)
    if (uuid) {
      return uuid
    }

    // 获取当前时间戳（毫秒）
    const timestamp = Date.now()
    // 生成随机数部分（4位16进制）
    let randomPart = Math.floor(Math.random() * 0x10000).toString(16)
    randomPart = Utils.padStart(randomPart, 4, '0')

    // 获取平台标识
    let os = 'web'
    if (typeof sys !== 'undefined' && sys && sys.os) {
      os = sys.os
    } else if (typeof navigator !== 'undefined') {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        os = 'ios'
      } else if (ua.indexOf('android') > -1) {
        os = 'android'
      }
    }

    // 组合成UUID
    // 后端限制 uid 长度为 32 位，所以去掉了 sys.platform
    uuid = `${os}-${timestamp.toString(16)}-${randomPart}`
    // 截取后32位
    uuid = uuid.slice(-32)
    localStorage.setItem(DataKeyDefine.UUID, uuid)
    return uuid
  }

  public static padStart(text: string, targetLength: number, padString: string = ' ') {
    const str = text + ''
    const diff = targetLength - str.length
    if (diff > 0) {
      padString = padString || ' '
      return (
        Array(diff / padString.length + 1)
          .join(padString)
          .slice(0, diff) + str
      )
    }
    return str
  }
}
